import axios from "functions/axios";

export const ListAgentsAPI = ({ page = 1, page_size = 15, search = "" } = {}) =>
  axios
    .get("user/agents/list_create/", {
      params: { page, page_size, search },
    })
    .then((res) => res.data);

export const ListAllAgentsAPI = ({ search = "" } = {}) =>
  axios
    .get("user/agents/all/", {
      params: { search },
    })
    .then((res) => res.data);

export const CreateAgentAPI = (payload) =>
  axios.post("user/agents/list_create/", payload).then((res) => res.data);

export const UpdateAgentsAPI = ({ agentID, locked }) =>
  axios.put(`user/agents/update/${agentID}/`, { locked }).then((res) => res.data);

export const RejectAgentAccountAPI = (agentID) =>
  axios.delete(`user/agents/reject/${agentID}/`).then((res) => res.data);

export const AcceptAgentAccountAPI = (agentID) =>
  axios.post(`user/agents/accept/${agentID}/`).then((res) => res.data);

export const ConvertAgentToUserAccountAPI = (agentID) =>
  axios.post(`user/agents/convert_to_user/${agentID}/`).then((res) => res.data);
